<template>
  <div class="error-container">
    <div class="card">
      <div class="code">403</div>

      <h1 class="title">شما دسترسی ندارید</h1>

      <p class="description">
        به نظر می‌رسه اجازه دسترسی به این صفحه رو نداری 😕
        <br />
      </p>

      <div class="actions">
        <router-link :to="{name:urlName}" class="btn secondary">
          بازگشت به خانه
        </router-link>

      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from 'vue'
import {useUserStore} from "@/store/user";
const urlName = ref('HomeView')
const userStore = useUserStore()
const data = computed(() => userStore.userInfo)
if(data.value){
  const permissionsSystem = data?.value.data?.permissions.some(item => item.category === "system")
  if(!permissionsSystem){
    urlName.value = 'DashboardManagement'
  }
}




</script>

<style scoped>


.card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(12px);
  padding: 50px;
  border-radius: 20px;
  text-align: center;
  width: 420px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  animation: float 3s ease-in-out infinite;
}

.code {
  font-size: 90px;
  font-weight: bold;
  background: linear-gradient(45deg, #38bdf8, #6366f1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.title {
  margin-top: 10px;
  font-size: 28px;
  color: #ffffff;
}

.description {
  margin: 20px 0 30px;
  color: #cbd5e1;
  font-size: 15px;
  line-height: 1.7;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.btn {
  padding: 10px 20px;
  border-radius: 12px;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
}

.primary {
  background: linear-gradient(45deg, #6366f1, #8b5cf6);
  color: white;
}

.primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.4);
}

.secondary {
  border: 1px solid #94a3b8;
  color: #e2e8f0;
}

.secondary:hover {
  background: rgba(255, 255, 255, 0.08);
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
  100% { transform: translateY(0px); }
}
</style>
